import * as Ably from 'ably'
import { ChatClient } from '@ably/chat'
import { supabase } from '@/integrations/supabase/client'

let ablyClient: Ably.Realtime | null = null
let chatClient: ChatClient | null = null

export async function getAblyClient(): Promise<Ably.Realtime> {
  if (!ablyClient) {
    // Generate token from Supabase Edge Function
    const { data: tokenData, error } = await supabase.functions.invoke('generate-ably-token')
    
    if (error) throw error

    ablyClient = new Ably.Realtime({
      authCallback: async (tokenParams, callback) => {
        try {
          const { data } = await supabase.functions.invoke('generate-ably-token')
          callback(null, data.tokenRequest)
        } catch (err) {
          callback(err as Error, null)
        }
      },
      clientId: tokenData.clientId,
      // Connection optimization
      recover: true,
      autoConnect: true,
      // Reduce connection overhead
      transports: ['websocket'],
      // Connection pooling
      connectionStateTtl: 30000,
      // Heartbeat optimization
      heartbeatInterval: 30000,
    })
  }

  return ablyClient
}

export async function getChatClient(): Promise<ChatClient> {
  if (!chatClient) {
    const ably = await getAblyClient()
    chatClient = new ChatClient(ably)
  }

  return chatClient
}

export function disconnectAbly() {
  if (chatClient) {
    chatClient.close()
    chatClient = null
  }
  if (ablyClient) {
    ablyClient.close()
    ablyClient = null
  }
}
